import { Component, Input } from '@angular/core';
import { toastListStyles, ToastProps } from '@kite_aerolab/shared/components';
import { animate, style, transition, trigger } from '@angular/animations';

export const toastListFadeAnimation = trigger('toastListFadeAnimation', [
  transition(':enter', [
    style({
      opacity: 0,
      marginRight: -30,
    }),
    animate(
      '300ms',
      style({
        opacity: 1,
        marginRight: 0,
      })
    ),
  ]),
  transition(':leave', [
    style({
      opacity: 1,
    }),
    animate(
      '300ms',
      style({
        opacity: 0,
        marginRight: -30,
      })
    ),
  ]),
]);

@Component({
  selector: 'kite-toast-list',
  animations: [toastListFadeAnimation],
  template: `
    <div class="toast-container" [ngClass]="toastList">
      <kite-toast
        @toastListFadeAnimation
        *ngFor="let toast of toasts"
        [title]="toast.title"
        [description]="toast.description"
        [variant]="toast.variant"
        [isOpen]="toast.isOpen"
        (click)="deleteToast(toast.id)"
        [ngStyle]="{ marginRight: -30 }"
      ></kite-toast>
    </div>
  `,
})
export class ToastListComponent {
  /**
   * Duración del toast en MS
   */
  @Input() duration = 5000;
  /**
   * Duración del toast en MS
   */
  @Input() autoHide = true;
  /**
   * Variante del toast (informative, warning o success)
   */
  @Input() css: ToastProps['css'];

  interval = setInterval(() => {
    if (this.toasts.length && this.autoHide) {
      this.deleteToast(String(this.toasts[0].id));
    }
  }, this.duration);

  /**
   * Duración del toast en MS
   */
  private _toasts: ToastProps[];

  get toasts(): ToastProps[] {
    return this._toasts;
  }

  @Input() set toasts(toasts: ToastProps[]) {
    this._toasts = toasts;
  }

  public get toastList(): string[] {
    return [toastListStyles({ css: this.css }).className];
  }

  if(interval: any) {
    clearInterval(interval);
  }

  deleteToast(id: string) {
    const listItemIndex = this.toasts.findIndex((e) => e.id === id);
    this.toasts.splice(listItemIndex, 1);
  }
}
